import { render } from "./BandeauBreadcrumb.vue?vue&type=template&id=109aa5ec&scoped=true&ts=true"
import script from "./BandeauBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./BandeauBreadcrumb.vue?vue&type=script&lang=ts"

import "./BandeauBreadcrumb.vue?vue&type=style&index=0&id=109aa5ec&scoped=true&lang=css"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109aa5ec"]])

export default __exports__